import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { getMyEmail } from '../../../utilities/identity';

interface WarmLeadPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onAddProperties: () => void;
}

const WarmLeadPopup: React.FC<WarmLeadPopupProps> = ({ isOpen, onClose, onAddProperties }) => {
  const userMail = getMyEmail()
  // Event handlers for button clicks
  const handleYes = () => {
    onAddProperties();
    onClose();
  };

  const handleNo = () => {
    const date = new Date();
    
    // Move to the first day of the next month
    date.setMonth(date.getMonth() + 1, 1);
    date.setHours(0, 0, 0, 0);
  
    // Calculate the day of the week for the first day of next month (0 = Sunday, 1 = Monday, etc.)
    const firstDayOfWeek = date.getDay();
  
    // Calculate how many days to add to reach the first Monday
    const daysUntilFirstMonday = (8 - firstDayOfWeek) % 7;
    date.setDate(date.getDate() + daysUntilFirstMonday);
  
    date.setDate(date.getDate() + 6);
  // cookie will expire on sec mon ( basically from second monday it will show )
    date.setHours(23, 59, 0, 0);
    localStorage.setItem(`warm_lead_${userMail}`, JSON.stringify({ value: true, expires: date.getTime() }));
  
    console.log("localstorage set to expire on:", date.toString());
    onClose();
  };
  

  // const handleNo = () => {
  //   const expirationTime = Date.now() + 60 * 60 * 1000; // Set expiration to one hour from now
  //   localStorage.setItem(`warm_lead_${userMail}`, JSON.stringify({ value: true, expires: expirationTime }));
  //   onClose();
  // };
  
  const warmLeadPopupString = localStorage.getItem(`warm_lead_${userMail}`);
  const warmLeadPopup = warmLeadPopupString ? JSON.parse(warmLeadPopupString) : null;
  
  if (warmLeadPopup && warmLeadPopup.value === true && warmLeadPopup.expires > Date.now()) {
    return <></>;
  }

  return (
    <Modal isOpen={isOpen} toggle={onClose} className="custom-modal">
      <ModalHeader toggle={onClose}>Warm Lead Opportunity</ModalHeader>
      <ModalBody>
        <p>Would you like to add new properties?</p>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleYes}>Yes</Button>{' '}
        <Button color="secondary" onClick={handleNo}>Remind Me Later</Button>{' '}
    {  /*  <Button color="danger" onClick={handleNever}>Never</Button>*/}
      </ModalFooter>
    </Modal>
  );
};

export default WarmLeadPopup;



// WEBPACK FOOTER //
// ./src/components/pages/admin/WarmLeadPopup.tsx